import {
  ApplicationConfig,
  InjectionToken,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { JsonRpc } from '@proton/js';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { MAINNET_ENDPOINTS, TESTNET_ENDPOINTS } from './constants/blockchain.constants';
import { provideHttpClient } from '@angular/common/http';

export const JSON_RPC = new InjectionToken<JsonRpc>('JSON_RPC');
export const JSON_RPC_ENDPOINTS = new InjectionToken<JsonRpc>('JSON_RPC_ENDPOINTS');

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    {
      provide: JSON_RPC_ENDPOINTS,
      useValue: environment.production ? MAINNET_ENDPOINTS : TESTNET_ENDPOINTS,
    },
    {
      provide: JSON_RPC,
      useFactory: (endpoints: string[]) => new JsonRpc(endpoints),
      deps: [JSON_RPC_ENDPOINTS],
    },
  ],
};
